<template>
  <ubi-page-container class="ubi-panel SocialPostEditorialCreate" wide-main-content :v-loading="loadingStatus && !hasSpecificLoading">
    <PostEditoCreateModalConfirmStopCustom></PostEditoCreateModalConfirmStopCustom>
    <dialog-planif-post-editorial ref="dialogPlanif" :post="post" @modal-closed="onPlanifModalClosed"></dialog-planif-post-editorial>
    <post-edito-create-modal-i-a :post="post"></post-edito-create-modal-i-a>
    <dialog-publish-now ref="dialogPublishNow" :post="post"></dialog-publish-now>
    <dialog-confirm-draft :visible.sync="showConfirmDraftModal" @confirm="onConfirmDraft" @cancel="onCancelDraft"></dialog-confirm-draft>
    <dialog-delete-planif-brouillon @draft-saved="onDraftSaved" @draft-error="onDraftError" @draft-cancelled="onDraftCancelled"></dialog-delete-planif-brouillon>
    <el-container>
      <el-form :model="post" :rules="rules" ref="formEdito" label-width="120px">
        <el-row>
          <el-col :lg="12">
            <post-edito-create-publication-initiale @updateValue="setError" :post="post"></post-edito-create-publication-initiale>
          </el-col>
          <el-col :lg="12">
            <post-edito-create-facebook :post="post"></post-edito-create-facebook>
            <post-edito-create-instagram :post="post"></post-edito-create-instagram>
            <post-edito-create-google :post="post"></post-edito-create-google>
            <post-edito-create-linkedin :post="post"></post-edito-create-linkedin>
          </el-col>
        </el-row>
      </el-form>

    </el-container>
    <el-dialog
      :title="$t('socialPosts.create.infoMediaType')"
      :visible.sync="dialogMediaImageAndVideo"
      width="30%" center
      @close="handleCloseModal">
      <span>{{$t('socialPosts.create.infoMediaTypeText')}}</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleChangeTypeMedia">{{$t('socialPosts.create.infoMediaTypeButton1')}}</el-button>
        <el-button @click="handleContinueAction" type="primary">{{$t('socialPosts.create.infoMediaTypeButton2')}}</el-button>
      </span>
    </el-dialog>
    <template v-if="browserContext.up('md')">
      <hr/>
      <div class="text-right mb-5" v-if="readOnly === false">
        <el-row>
          <el-button type="warning" v-if="(edit && post.etat && (post.etat === 'A' || post.etat === 'M'))" @click="onSubmit(post.etat)" :disabled="draftButtonAvailable || !hasMediaContent || isActionLocked" :loading="loadingSave">
            Enregistrer les modifications
          </el-button>
          <el-tooltip class="item" effect="dark" :content="$t('socialPosts.create.validator.fieldsRequired')"
                      placement="bottom" v-if="isDraftButtonDisabled && !model">
            <el-button :disabled="isDraftButtonDisabled || isActionLocked" :loading="loadingDraft" type="danger">{{$t('socialPosts.create.saveDraft')}}</el-button>
          </el-tooltip>
          <el-button type="danger" @click="onSubmit('B')" :disabled="isDraftButtonDisabled || isActionLocked" :loading="loadingDraft" v-else>{{$t('socialPosts.create.saveDraft')}}</el-button>

          <el-tooltip class="item" effect="dark" :content="$t('socialPosts.create.validator.fieldsRequiredComplete')"
                      placement="bottom" v-if="isPublishButtonDisabled && !model">
            <el-button type="success" :disabled="isPublishButtonDisabled || isActionLocked" :loading="loadingPublish" @click="onSubmit('A')">{{$t('socialPosts.create.core.publish')}}</el-button>
          </el-tooltip>
          <el-tooltip class="item" effect="dark" :content="$t('socialPosts.create.validator.fieldsRequired')"
                      placement="bottom" v-else-if="isDraftButtonDisabled && !isPublishButtonDisabled && !model">
            <el-button type="success" :disabled="isDraftButtonDisabled || isActionLocked" :loading="loadingPublish" @click="onSubmit('A')">{{$t('socialPosts.create.core.publish')}}</el-button>
          </el-tooltip>

          <el-dropdown placement="top" @command="handleplanningActions" v-else-if="!model">
            <el-button type="success" :disabled="isPublishButtonDisabled || isActionLocked" :loading="loadingPublish || loadingPlanification" style="margin-left: 10px">
              {{$t('socialPosts.create.core.publish')}}
            </el-button>
            <el-dropdown-menu slot="dropdown" v-if="!model">
              <el-dropdown-item command="schedule"><i class="el-icon-date"></i> {{$t('general.calendar.scheduled')}}</el-dropdown-item>
              <el-dropdown-item command="publishNow"><i class="el-icon-share"></i> {{$t('general.calendar.publishNow')}}</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
          <el-button v-else-if="model" type="success" @click="onSubmit('M')" :disabled="isActionLocked" :loading="loadingSave">{{ $t('socialPosts.models.saveModel') }}</el-button>
          <el-button @click="annuler()" style="margin-left: 10px;" :disabled="isActionLocked || loadingCancel" :loading="loadingCancel">{{$t('socialPosts.create.core.cancel')}}</el-button>

        </el-row>
      </div>
      <div class="text-right" v-else>
        <el-row>
          <el-button @click="annuler()" style="margin-left: 10px;" :disabled="loadingCancel" :loading="loadingCancel">{{$t('socialPosts.create.core.returnToList')}}</el-button>
        </el-row>
      </div>
    </template>
  </ubi-page-container>
</template>

<script>
import UbiPanel from '@/components/Panel'
import { Upload } from 'element-ui'
import { capitalize } from 'lodash/string'
import { mapActions, mapGetters, mapMutations, mapState } from 'vuex'
import Emoji from '@/components/emojis/Emoji'
import moment from 'moment'
import PostEditoCreatePublicationInitiale from '@/pages/socialNetworks/components/PostEditoCreatePublicationInitiale'
import PostEditoCreateFacebook from '@/pages/socialNetworks/components/PostEditoCreateFacebook'
import PostEditoCreateInstagram from '@/pages/socialNetworks/components/PostEditoCreateInstagram'
import PostEditoCreateGoogle from '@/pages/socialNetworks/components/PostEditoCreateGoogle'
import PostEditoCreateLinkedin from '@/pages/socialNetworks/components/PostEditoCreateLinkedin'
import DialogPlanifPostEditorial from '@/pages/socialNetworks/components/DialogPlanifPostEditorial'
import PostEditoCreateModalConfirmStopCustom
  from '@/pages/socialNetworks/components/PostEditoCreateModalConfirmStopCustom'
import PostEditoCreateModalIA from '@/pages/socialNetworks/components/PostEditoCreateModalIA'
import DialogPublishNow from '@/pages/socialNetworks/components/DialogPublishNow'
import DialogConfirmDraft from '@/pages/socialNetworks/components/DialogConfirmDraft.vue'
import DialogDeletePlanifBrouillon from '@/pages/socialNetworks/components/DialogDeletePlanifBrouillon.vue'
import router from '@/router'
import { urlIsValid } from '@/services/socialNetworkTools'
import { HTTP_HYPER_ESPACE_BACKEND } from '@/services/http-common'
import PostEditoValidationMixin from '@/mixins/PostEditoValidationMixin'
import UbiPageContainer from '@/components/PageContainer.vue'

export default {
  name: 'SocialPostEditorialCreate',
  components: {
    UbiPageContainer,
    UbiPanel,
    ElUpload: Upload,
    Emoji,
    PostEditoCreatePublicationInitiale,
    PostEditoCreateFacebook,
    PostEditoCreateInstagram,
    PostEditoCreateGoogle,
    PostEditoCreateLinkedin,
    DialogPlanifPostEditorial,
    PostEditoCreateModalConfirmStopCustom,
    PostEditoCreateModalIA,
    DialogPublishNow,
    DialogConfirmDraft,
    DialogDeletePlanifBrouillon
  },
  inject: ['browserContext'],
  mixins: [PostEditoValidationMixin],
  data () {
    const checkUrl = (rule, value, callback) => {
      const url = this.$store.state.socialPostsCreationPostEditorial.post.initial.linkToVideo
      const regexUrl = new RegExp(
        '^' +
          // protocol identifier (optional)
          // short syntax // still required
          '(?:(?:(?:https?|ftp):)?\\/\\/)' +
          // user:pass BasicAuth (optional)
          '(?:\\S+(?::\\S*)?@)?' +
          '(?:' +
          // IP address exclusion
          // private & local networks
          '(?!(?:10|127)(?:\\.\\d{1,3}){3})' +
          '(?!(?:169\\.254|192\\.168)(?:\\.\\d{1,3}){2})' +
          '(?!172\\.(?:1[6-9]|2\\d|3[0-1])(?:\\.\\d{1,3}){2})' +
          // IP address dotted notation octets
          // excludes loopback network 0.0.0.0
          // excludes reserved space >= 224.0.0.0
          // excludes network & broadcast addresses
          // (first & last IP address of each class)
          '(?:[1-9]\\d?|1\\d\\d|2[01]\\d|22[0-3])' +
          '(?:\\.(?:1?\\d{1,2}|2[0-4]\\d|25[0-5])){2}' +
          '(?:\\.(?:[1-9]\\d?|1\\d\\d|2[0-4]\\d|25[0-4]))' +
          '|' +
          // host & domain names, may end with dot
          // can be replaced by a shortest alternative
          // (?![-_])(?:[-\\w\\u00a1-\\uffff]{0,63}[^-_]\\.)+
          '(?:' +
          '(?:' +
          '[a-z0-9\\u00a1-\\uffff]' +
          '[a-z0-9\\u00a1-\\uffff_-]{0,62}' +
          ')?' +
          '[a-z0-9\\u00a1-\\uffff]\\.' +
          ')+' +
          // TLD identifier name, may end with dot
          '(?:[a-z\\u00a1-\\uffff]{2,}\\.?)' +
          ')' +
          // port number (optional)
          '(?::\\d{2,5})?' +
          // resource path (optional)
          '(?:[/?#]\\S*)?' +
          '$', 'i'
      )

      // const regexUrl = new RegExp('^((https?|ftp|smtp):\/\/)?(www.)?[a-z0-9]+\.[a-z]+(\/[a-zA-Z0-9#]+\/?)*$')
      if (url && !regexUrl.test(url)) {
        return callback(new Error(this.$t('URL Non valide')))
      }
      callback()
    }
    const checkLibelleInitial = (rule, value, callback) => {
      const libelle = this.$store.state.socialPostsCreationPostEditorial.post.initial.libelle
      if (libelle === null || libelle.length === 0) {
        return callback(this.$t('validator.isRequired'))
      }
      callback()
    }
    const checkTexteInitial = (rule, value, callback) => {
      const inputText = this.$store.state.socialPostsCreationPostEditorial.post.initial.inputText
      if (!inputText || inputText.length === 0) {
        return callback(this.$t('validator.isRequired'))
      }
      callback()
    }
    const checkTexteFacebook = (rule, value, callback) => {
      const inputText = this.$store.state.socialPostsCreationPostEditorial.post.facebook.inputText
      if (!inputText || inputText.length === 0) {
        return callback(this.$t('validator.isRequired'))
      }
      callback()
    }
    const checkTexteLinkedIn = (rule, value, callback) => {
      const inputText = this.$store.state.socialPostsCreationPostEditorial.post.linkedin.inputText
      if (!inputText || inputText.length === 0) {
        return callback(this.$t('validator.isRequired'))
      }
      callback()
    }
    const checkTexteGoogle = (rule, value, callback) => {
      const inputText = this.$store.state.socialPostsCreationPostEditorial.post.google.inputText
      if (!inputText || inputText.length === 0) {
        return callback(this.$t('validator.isRequired'))
      }
      callback()
    }
    const checkDatesGoogle = (rule, value, callback) => {
      let inputDatesCheck = false
      if (this.$store.state.socialPostsCreationPostEditorial.post.google.offerDateBefore && this.$store.state.socialPostsCreationPostEditorial.post.google.offerDateAfter) {
        inputDatesCheck = true
      }
      if (!inputDatesCheck) {
        return callback(this.$t('validator.isRequired'))
      }
      callback()
    }
    const checkTexteInstagram = (rule, value, callback) => {
      const inputText = this.$store.state.socialPostsCreationPostEditorial.post.instagram.inputText
      if (!inputText || inputText.length === 0) {
        return callback(this.$t('validator.isRequired'))
      }
      callback()
    }
    return {
      post: {},
      model: false,
      network: null,
      modalPlanif: false,
      fromReseau: false,
      titleLabel: 'Création',
      typePostInput: null,
      libellePostInput: null,
      title: null,
      texteInput: null,
      linkToVideo: null,
      promoCodeInput: null,
      offerLinkInput: null,
      offerConditionsInput: null,
      offerBeforeInput: null,
      offerAfterInput: null,
      eventBeforeInput: null,
      eventAfterInput: null,
      actionButtonInput: null,
      offerTimeInput: null,
      promptIA: null,
      eventLinkInput: null,
      sendToStoryInput: false,
      generatedText: null,
      datePlanifInput: null,
      UTMInput: null,
      typePostInstagram: null,
      typePlanif: null,
      redirect: false,
      linkToVideoInstagramInput: null,
      publishToStoryInstagramInput: false,
      legendePhoto: this.$t('socialPosts.create.imageDescription'),
      pickerOptions: {},
      urlPhotoInput: null,
      readOnly: false,
      errors: {},
      isInitialLoad: true,
      pendingSubmitType: null,
      isSubmitting: false,
      loadingSave: false,
      loadingDraft: false,
      loadingPublish: false,
      loadingCancel: false,
      loadingPlanification: false,
      showConfirmDraftModal: false,
      rules: {
        texteInputInitial: { validator: checkTexteInitial, trigger: 'blur' },
        texteInputFacebook: { validator: checkTexteFacebook, trigger: 'blur' },
        texteInputInstagram: { validator: checkTexteInstagram, trigger: 'blur' },
        texteInputGoogle: { validator: checkTexteGoogle, trigger: 'blur' },
        texteInputLinkedIn: { validator: checkTexteLinkedIn, trigger: 'blur' },
        libellePostInput: { validator: checkLibelleInitial, trigger: 'blur' },
        // eventAfterInput: { required: true, message: this.$t('validator.isRequired'), trigger: 'blur' },
        // eventBeforeInput: { required: true, message: this.$t('validator.isRequired'), trigger: 'blur' },
        // eventLinkInput: { validator: checkUrl, trigger: 'blur' },
        urlPhoto: { validator: checkUrl, trigger: 'blur' },
        urlToVideoInitial: { validator: checkUrl, trigger: 'blur' },
        eventDatesGoogle: { validator: checkDatesGoogle, trigger: 'blur' }
        // eventBeforeInputGoogle: { required: true, message: this.$t('validator.isRequired'), trigger: 'blur' },
        // eventAfterInputGoogle: { required: true, message: this.$t('validator.isRequired'), trigger: 'blur' }
      },
      // Ajouter ces propriétés pour tracker l'état initial des réseaux
      initialNetworkState: {
        facebookChecked: false,
        instagramChecked: false,
        googleChecked: false,
        linkedInChecked: false
      }
    }
  },
  computed: {
    ...mapState('socialPostsCreationPostEditorial',
      [
        'modalIA',
        'libelle',
        'texte',
        'typePost',
        'photo',
        'edit',
        'create',
        'actionButton',
        'datePlanif',
        'promoCode',
        'eventBefore',
        'eventAfter',
        'offerLink',
        'offerTime',
        'offerConditions',
        'offerBefore',
        'offerAfter',
        'modalIA',
        'loadingStatus',
        'currentPost',
        'redirection',
        'publishButtonAvailable',
        'draftButtonAvailable',
        'modalConfirmPublish',
        'modalDeletePlanifBrouillons'
      ]
    ),
    ...mapGetters('socialPostsCreationPostEditorial', ['getStateDefault', 'getStatusMediaPost']),
    dialogMediaImageAndVideo: {
      get () {
        return this.$store.getters['socialPostsCreationPostEditorial/modalMediaImageAndVideo']
      },
      set (value) {
        this.$store.commit('socialPostsCreationPostEditorial/setModalMediaImageAndVideo', value)
      }
    },
    sitimmoUser () {
      return this.$store.getters.getSitimmoUser
    },
    hasSpecificLoading () {
      // Retourne true si au moins un loader spécifique est actif
      return this.isSubmitting || this.loadingSave || this.loadingDraft || this.loadingPublish || this.loadingCancel || this.loadingPlanification
    },
    isActionLocked () {
      return this.isSubmitting || this.loadingSave || this.loadingDraft || this.loadingPublish || this.loadingPlanification
    },
    // Getters pour les checkboxes des réseaux sociaux
    facebookChecked () {
      return this.$store.getters['socialPostsCreationPostEditorial/getFacebookChecked']
    },
    instagramChecked () {
      return this.$store.getters['socialPostsCreationPostEditorial/getInstagramChecked']
    },
    googleChecked () {
      return this.$store.getters['socialPostsCreationPostEditorial/getGoogleChecked']
    },
    linkedInChecked () {
      return this.$store.getters['socialPostsCreationPostEditorial/getLinkedInChecked']
    },
    // Détecter les nouveaux réseaux ajoutés depuis le chargement initial
    newlyAddedNetworks () {
      const newNetworks = []

      // Comparer l'état actuel avec l'état initial
      if (this.facebookChecked && !this.initialNetworkState.facebookChecked) {
        newNetworks.push('Facebook')
      }
      if (this.instagramChecked && !this.initialNetworkState.instagramChecked) {
        newNetworks.push('Instagram')
      }
      if (this.googleChecked && !this.initialNetworkState.googleChecked) {
        newNetworks.push('Google')
      }
      if (this.linkedInChecked && !this.initialNetworkState.linkedInChecked) {
        newNetworks.push('LinkedIn')
      }

      return newNetworks
    }
  },
  methods: {
    router () {
      return router
    },
    ...mapMutations('socialPostsCreationPostEditorial', [
      'setLibelle',
      'setTypePost',
      'setTexte',
      'setPhoto',
      'setActionButton',
      'setDatePlanif',
      'setEdit',
      'setCreate',
      'setPromoCode',
      'setEventBefore',
      'setEventAfter',
      'setOfferLink',
      'setOfferTime',
      'setOfferConditions',
      'setOfferBefore',
      'setOfferAfter',
      'setModalIA',
      'setLoadingStatus',
      'setUTM',
      'setPublishToStoryInstagram',
      'setLinkToVideoInstagram',
      'setTypePostInstagram',
      'setEventLink',
      'setNetwork',
      'setLoadingStatusIAGeneration',
      'resetState',
      'resetRedirection',
      'setRedirection',
      'setDefaultPost',
      'SET_MODAL_DELETE_PLANIF_BROUILLONS'
    ]),
    ...mapActions('socialPostsCreationPostEditorial',
      ['validatePost', 'analyzePostMedias']),
    // Méthode personnalisée pour validatePost qui gère nos loaders
    async validatePostWithLoader (payload) {
      try {
        // Appeler l'action du store
        await this.$store.dispatch('socialPostsCreationPostEditorial/validatePost', payload)
        // Attendre que le store ait fini ses opérations
        await this.$nextTick()
      } catch (error) {
        throw error
      } finally {
        // Désactiver nos loaders spécifiques à la fin
        if (payload.typePost === 'B') {
          this.loadingDraft = false
        } else if (payload.typePost === 'A') {
          this.loadingPublish = false
        } else if (payload.typePost === 'M') {
          this.loadingSave = false
        } else {
          this.loadingSave = false
        }
      }
    },
    validateFormField (fieldName) {
      if (this.$refs.formEdito) {
        this.$refs.formEdito.validateField(fieldName)
      }
    },
    handleRemove (file) {
      console.log(file)
    },
    handlePreview (file) {
      this.dialogImageUrl = file.url
    },
    handleDownload (file) {
      console.log(file)
    },
    test () {
      console.log(this.photosInput)
    },
    setError (errorKey, errorMessage) {
      if (errorMessage === 'delete') {
        delete this.errors[errorKey]
      } else {
        this.errors[errorKey] = errorMessage
      }
    },
    handleplanningActions (command) {
      if (this.isActionLocked) {
        return
      }
      // console.log('handleplanningActions', command)
      switch (command) {
        case 'schedule':
          this.openModalPublish()
          break
        case 'publishNow':
          // this.onSubmit('A')
          this.openModalPublishNow()
          break
      }
    },
    openModalPublish () {
      this.loadingPlanification = true
      this.$store.commit('socialPostsCreationPostEditorial/setModalConfirmPublish', true)
      // Le loader sera désactivé dans handleContinueAction ou handleChangeTypeMedia
    },
    openModalPublishNow () {
      this.loadingPublish = true
      this.$store.commit('socialPostsCreationPostEditorial/setModalConfirmPublishNow', true)
      // Le loader sera désactivé dans handleContinueAction ou handleChangeTypeMedia
    },
    handleForm () {
      const valid = this.handleUrlsVideo()
      if (!valid) {
        this.$store.commit('socialPostsCreationPostEditorial/setDraftButtonAvailable', true)
        this.$store.commit('socialPostsCreationPostEditorial/setPublishButtonAvailable', true)
        this.tabs[1].disabled = true
        this.tabs[2].disabled = true
      }
      return valid
    },
    handleUrlsVideo () {
      const errors = []
      if (this.post.initial.linkToVideo) {
        if (!urlIsValid(this.post.initial.linkToVideo)) {
          errors.push('Initiale')
        }
      }
      if (this.post.facebook.linkToVideo) {
        if (!urlIsValid(this.post.facebook.linkToVideo)) {
          errors.push('Facebook')
        }
      }
      if (this.post.google.linkToVideo) {
        if (!urlIsValid(this.post.google.linkToVideo)) {
          errors.push('Google')
        }
      }
      if (this.post.instagram.linkToVideo) {
        if (!urlIsValid(this.post.instagram.linkToVideo)) {
          errors.push('Instagram')
        }
      }
      if (this.post.linkedin.linkToVideo) {
        if (!urlIsValid(this.post.linkedin.linkToVideo)) {
          errors.push('Linkedin')
        }
      }
      const valid = errors.length <= 0
      if (!valid) {
        this.$message.error("L'url de la vidéo n'est pas valide pour: " + errors.join(', '))
      }
      return valid
    },
    onSubmit (type) {
      if (this.isSubmitting) {
        return
      }
      if (type !== 'B' && this.isActionLocked) {
        return
      }

      // Si c'est un enregistrement en brouillon, activer le loader et afficher la modale de confirmation
      if (type === 'B') {
        if (this.isActionLocked) {
          return
        }
        this.loadingDraft = true
        this.pendingSubmitType = type
        this.showConfirmDraftModal = true
        return
      }

      // Vérifier s'il y a un conflit de médias avant de soumettre
      if (this.$store.getters['socialPostsCreationPostEditorial/hasMediaConflict']) {
        // Stocker le type d'action pour l'exécuter après la fermeture de la modale
        this.pendingSubmitType = type
        this.$store.commit('socialPostsCreationPostEditorial/setModalMediaImageAndVideo', true)
        return
      }

      // Vérifier s'il y a de nouveaux réseaux ajoutés lors de la modification
      if (this.edit && (type === 'A' || type === 'M')) {
        const newNetworks = this.newlyAddedNetworks
        if (newNetworks.length > 0) {
          // Il y a de nouveaux réseaux ajoutés, proposer la modale de planification
          const networkNames = newNetworks.join(', ')
          this.$message.info(`De nouveaux réseaux ont été ajoutés (${networkNames}). Veuillez configurer leur planification.`)
          this.openModalPublish()
          return
        }
      }

      this.executeSubmit(type)
    },
    async executeSubmit (type) {
      if (this.isSubmitting) {
        return
      }

      let deferSubmitUnlock = false

      if (this.handleForm()) {
        let exit = 0
        this.$refs.formEdito.validate((valid) => {
          if (!valid) {
            this.$message.error('Vous n\'avez pas renseigné tous les champs obligatoires')
            exit = 1
          }
        })
        if (exit === 0) {
          this.isSubmitting = true

          // Activer le loader approprié selon le type d'action (si pas déjà actif)
          if (type === 'B' && !this.loadingDraft) {
            this.loadingDraft = true
          } else if (type === 'A' && !this.loadingPublish) {
            this.loadingPublish = true
          } else if (type === 'M' && !this.loadingSave) {
            this.loadingSave = true
          } else if (!this.loadingSave && type !== 'B' && type !== 'A') {
            this.loadingSave = true // Pour les modifications
          }

          try {
            if (type === 'B' && this.post.planifications && this.post.planifications.length > 0) {
              deferSubmitUnlock = true
              this.SET_MODAL_DELETE_PLANIF_BROUILLONS(true)
              // Ne pas désactiver le loader ici, il sera désactivé après la gestion de la modale
            } else {
              await this.validatePostWithLoader({ typePost: type })
            }
          } catch (error) {
            console.error('Erreur lors de la soumission:', error)
            // Désactiver les loaders en cas d'erreur
            this.loadingDraft = false
            this.loadingPublish = false
            this.loadingSave = false
          } finally {
            if (!deferSubmitUnlock) {
              this.isSubmitting = false
            }
          }
        } else {
          // Si la validation échoue, désactiver le loader
          if (type === 'B') {
            this.loadingDraft = false
          } else if (type === 'A') {
            this.loadingPublish = false
          } else {
            this.loadingSave = false
          }
        }
      } else {
        // Si handleForm échoue, désactiver le loader
        if (type === 'B') {
          this.loadingDraft = false
        } else if (type === 'A') {
          this.loadingPublish = false
        } else {
          this.loadingSave = false
        }
      }
    },
    async annuler () {
      this.loadingCancel = true

      try {
        if (this.$route.name === 'new-post-editorial' && this.post.id) {
          await this.$store.dispatch('socialPostsCreationPostEditorial/deletePostEditorial', this.post.id)
        }
        if (this.$route.name === '' && this.post.id) {
          await this.$store.dispatch('socialPostsCreationPostEditorial/deletePostEditorial', this.post.id)
        }
        if (this.$route.name === 'post-editorial-modeles-use' && this.post.id) {
          await this.$store.dispatch('socialPostsCreationPostEditorial/deletePostEditorial', this.post.id)
        }

        if (this.$route.name === 'post-editorial-modeles-use' || this.$route.name === 'post-editorial-modeles-create' || this.$route.name === 'post-editorial-modeles-edit') {
          this.$router.push({ name: 'post-editorial-modeles' })
        } else {
          // Définir l'onglet "Posts Editoriaux" comme actif avant la redirection
          this.$store.commit('socialNetworkPosts/setCurrentTab', 'PostsEditoriaux')
          this.$router.push({ name: 'social-posts' })
        }

        // Pour vidéo
        const pathVideoTemp = this.$store.getters['socialPostsCreationPostEditorial/getUploadedVideoPath']
        if (pathVideoTemp) {
          HTTP_HYPER_ESPACE_BACKEND.delete('/upload/videos/delete', {
            data: { path: pathVideoTemp }
          }).then(() => {
            // Supprimer le path
            this.$store.commit('socialPostsCreationPostEditorial/setStatusMediasPost', { key: 'hasVideoUpload', value: false })
            this.$store.commit('socialPostsCreationPostEditorial/clearUploadedVideoPath')
            // S'assurer qu'il y a de redirection lors de la suppression de vidéo
            this.$store.commit('socialPostsCreationPostEditorial/setRedirection', true)
            // Mettre à jour l'état des boutons après la suppression de la vidéo
            this.$store.commit('socialPostsCreationPostEditorial/checkPublishButtonState')
            this.$store.commit('socialPostsCreationPostEditorial/checkDraftButtonState')
            this.$store.dispatch('socialPostsCreationPostEditorial/loadSocialPostEditorialById', this.post.id)
          })
        }
      } catch (error) {
        console.error('Erreur lors de l\'annulation:', error)
        // Redirection malgré l'erreur
        if (this.$route.name === 'post-editorial-modeles-use' || this.$route.name === 'post-editorial-modeles-create' || this.$route.name === 'post-editorial-modeles-edit') {
          this.$router.push({ name: 'post-editorial-modeles' })
        } else {
          // Définir l'onglet "Posts Editoriaux" comme actif avant la redirection
          this.$store.commit('socialNetworkPosts/setCurrentTab', 'PostsEditoriaux')
          this.$router.push({ name: 'social-posts' })
        }
      } finally {
        this.loadingCancel = false
      }
    },
    addEmoji (emoji) {
      this.emojiDisplay = true
      const insertText = emoji
      if (!insertText.length) {
        return
      }
      const textarea = this.$refs.textareaPostEdito.$el.querySelector('.el-textarea__inner')
      let cursorIndex = textarea.selectionEnd
      if (textarea.innerHTML === '' && !this.texteInput) {
        textarea.innerHTML += insertText
      }
      if (this.post.texteInput) {
        this.post.texteInput = this.texteInput.substring(0, cursorIndex) + insertText + this.texteInput.substring(cursorIndex)
      }
      setTimeout(() => {
        cursorIndex += insertText.length
        textarea.selectionStart = textarea.selectionEnd = cursorIndex
      }, 10)
    },
    async handleContinueAction () {
      this.$store.commit('socialPostsCreationPostEditorial/setModalMediaImageAndVideo', false)

      try {
        // Analyser les médias pour mettre à jour le statut après changement
        await this.analyzePostMedias()

        // Exécuter l'action en attente si elle existe
        if (this.pendingSubmitType) {
          await this.executeSubmit(this.pendingSubmitType)
          this.pendingSubmitType = null
        } else {
          // Gérer les nouvelles actions stockées dans pendingActionType
          const pendingActionType = this.$store.state.socialPostsCreationPostEditorial.pendingActionType
          if (pendingActionType === 'validatePlanification') {
            // Fermer la modale de planification et appeler l'action
            this.$store.commit('socialPostsCreationPostEditorial/setModalConfirmPublish', false)
            await this.$store.dispatch('socialPostsCreationPostEditorial/handlePublish')
          } else if (pendingActionType === 'publishNow') {
            // Fermer la modale de publication maintenant et appeler l'action
            this.$store.commit('socialPostsCreationPostEditorial/setModalConfirmPublishNow', false)
            await this.$store.dispatch('socialPostsCreationPostEditorial/handlePublish')
          }
          // Réinitialiser le type d'action en cours
          this.$store.commit('socialPostsCreationPostEditorial/setPendingActionType', null)
        }
      } catch (error) {
        console.error('Erreur lors de l\'action:', error)
      } finally {
        // Désactiver tous les loaders
        this.isSubmitting = false
        this.loadingDraft = false
        this.loadingPublish = false
        this.loadingSave = false
        this.loadingPlanification = false
      }
    },
    async handleChangeTypeMedia () {
      this.$store.commit('socialPostsCreationPostEditorial/setModalMediaImageAndVideo', false)
      // Annuler l'action en attente
      this.pendingSubmitType = null
      this.$store.commit('socialPostsCreationPostEditorial/setPendingActionType', null)
      // Désactiver tous les loaders
      this.isSubmitting = false
      this.loadingDraft = false
      this.loadingPublish = false
      this.loadingSave = false
      this.loadingPlanification = false
      // Analyser les médias pour mettre à jour le statut après changement de type
      await this.analyzePostMedias()
      console.log('change type media')
    },
    async handleCloseModal () {
      this.$store.commit('socialPostsCreationPostEditorial/setModalMediaImageAndVideo', false)
      // Annuler l'action en attente
      this.pendingSubmitType = null
      // Analyser les médias pour mettre à jour le statut
      await this.analyzePostMedias()
      this.$store.commit('socialPostsCreationPostEditorial/setPendingActionType', null)
      // Désactiver tous les loaders
      this.isSubmitting = false
      this.loadingDraft = false
      this.loadingPublish = false
      this.loadingSave = false
      this.loadingPlanification = false
    },
    // Méthodes pour gérer la modale de confirmation de brouillon
    async onConfirmDraft () {
      // L'utilisateur a confirmé, on continue avec l'enregistrement
      const type = this.pendingSubmitType

      // Fermer la modale immédiatement
      this.showConfirmDraftModal = false

      // S'assurer que le loader reste actif après la fermeture de la modale
      if (type === 'B') {
        this.loadingDraft = true
      }

      // Attendre le prochain cycle de rendu pour s'assurer que le loader est visible
      await this.$nextTick()

      // Continuer avec les vérifications normales
      // Vérifier s'il y a un conflit de médias avant de soumettre
      if (this.$store.getters['socialPostsCreationPostEditorial/hasMediaConflict']) {
        this.pendingSubmitType = type
        this.$store.commit('socialPostsCreationPostEditorial/setModalMediaImageAndVideo', true)
        return
      }

      // Réinitialiser pendingSubmitType avant d'exécuter
      this.pendingSubmitType = null

      // Exécuter la soumission
      this.executeSubmit(type)
    },
    onCancelDraft () {
      // L'utilisateur a annulé, on nettoie
      this.pendingSubmitType = null
      this.showConfirmDraftModal = false
      this.isSubmitting = false
      this.loadingDraft = false
    },
    // Méthodes pour gérer les événements de la modale de brouillon
    onDraftSaved () {
      // Désactiver le loader quand le brouillon est sauvegardé avec succès
      this.isSubmitting = false
      this.loadingDraft = false
    },
    onDraftError (error) {
      // Désactiver le loader en cas d'erreur
      this.isSubmitting = false
      this.loadingDraft = false
      this.$message.error('Erreur lors de la sauvegarde du brouillon')
    },
    onDraftCancelled () {
      // Désactiver le loader quand l'utilisateur annule
      this.isSubmitting = false
      this.loadingDraft = false
    },
    onPlanifModalClosed () {
      // Désactiver le loader de planification quand la modale se ferme
      this.loadingPlanification = false
    },
    // Nouvelle méthode pour sauvegarder l'état initial des réseaux
    saveInitialNetworkState () {
      this.initialNetworkState = {
        facebookChecked: this.facebookChecked,
        instagramChecked: this.instagramChecked,
        googleChecked: this.googleChecked,
        linkedInChecked: this.linkedInChecked
      }
      // console.log('État initial des réseaux sauvegardé:', this.initialNetworkState)
    }
  },
  watch: {
    'post.initial.inputText': function () {
      if (!this.isInitialLoad) {
        this.$nextTick(() => {
          this.validateFormField('texteInputInitial')
        })
      }
    },
    'post.facebook.inputText': function () {
      if (!this.isInitialLoad) {
        this.$nextTick(() => {
          this.validateFormField('texteInputFacebook')
        })
      }
    },
    'post.instagram.inputText': function () {
      if (!this.isInitialLoad) {
        this.$nextTick(() => {
          this.validateFormField('texteInputInstagram')
        })
      }
    },
    'post.google.inputText': function () {
      if (!this.isInitialLoad) {
        this.$nextTick(() => {
          this.validateFormField('texteInputGoogle')
        })
      }
    },
    'post.linkedin.inputText': function () {
      if (!this.isInitialLoad) {
        this.$nextTick(() => {
          this.validateFormField('texteInputLinkedIn')
        })
      }
    },
    'post.initial.libelle': function () {
      if (!this.isInitialLoad) {
        this.$nextTick(() => {
          this.validateFormField('libellePostInput')
        })
      }
    },
    redirection: function (newValue, oldValue) {
      // Déclencher la navigation quand redirection passe à true
      if (newValue === true) {
        if (this.$route.name === 'post-editorial-modeles-create' || this.$route.name === 'post-editorial-modeles-edit') {
          // Pour la création et l'édition de modèles, retourner à la bibliothèque des modèles
          this.$router.push({ name: 'post-editorial-modeles' })
        } else {
          // Pour l'utilisation d'un modèle ou les autres cas, retourner à la gestion des posts
          // Définir l'onglet "Posts Editoriaux" comme actif avant la redirection
          this.$store.commit('socialNetworkPosts/setCurrentTab', 'PostsEditoriaux')
          this.$router.push({ name: 'social-posts' })
        }
      }
    },
    // Watcher pour mettre à jour l'état du bouton brouillon
    isDraftButtonDisabled: {
      handler (newValue) {
        this.$store.commit('socialPostsCreationPostEditorial/setDraftButtonAvailable', newValue)
      },
      immediate: true
    },

    // Watcher pour mettre à jour l'état du bouton publier
    isPublishButtonDisabled: {
      handler (newValue) {
        this.$store.commit('socialPostsCreationPostEditorial/setPublishButtonAvailable', newValue)
      },
      immediate: true
    },

    // Watcher pour forcer la mise à jour quand hasMediaContent change
    hasMediaContent: {
      handler () {
        this.$nextTick(() => {
          this.$store.commit('socialPostsCreationPostEditorial/setDraftButtonAvailable', this.isDraftButtonDisabled)
          this.$store.commit('socialPostsCreationPostEditorial/setPublishButtonAvailable', this.isPublishButtonDisabled)
        })
      },
      immediate: true
    },
    // Watcher pour détecter quand le post est complètement chargé
    loadingStatus: function (newValue, oldValue) {
      // Quand le loading passe de true à false, le post est chargé
      if (oldValue === true && newValue === false && this.edit) {
        this.$nextTick(() => {
          this.saveInitialNetworkState()
        })
      }
    }
  },
  mounted () {
    this.$store.commit('socialPostsCreationPostEditorial/checkPublishButtonState')
    this.$store.commit('socialPostsCreationPostEditorial/checkDraftButtonState')
    // Analyser les médias pour mettre à jour le statut (y compris les médias temporaires)
    this.analyzePostMedias()
    // Désactiver le flag de chargement initial après le premier cycle de rendu
    this.$nextTick(() => {
      this.isInitialLoad = false

      // Pour les nouveaux posts (création), sauvegarder l'état initial immédiatement
      if (this.create) {
        this.saveInitialNetworkState()
      }
    })
  },
  beforeRouteLeave (to, from, next) {
    if (this.redirection === false) {
      const answer = window.confirm('Vous êtes sur le point de quitter ce formulaire de création d\'un post sans l\'avoir enregistré. Souhaitez-vous vraiment annuler votre création de post ?')
      if (answer) {
        this.$store.commit('socialPostsCreationPostEditorial/resetPost')
        this.$store.commit('socialPostsCreationPostEditorial/setCustomFacebook', false)
        this.$store.commit('socialPostsCreationPostEditorial/setCustomGoogle', false)
        this.$store.commit('socialPostsCreationPostEditorial/setCustomInstagram', false)
        this.$store.commit('socialPostsCreationPostEditorial/setCustomLinkedIn', false)
        this.$store.commit('socialPostsCreationPostEditorial/setFacebookChecked', false)
        this.$store.commit('socialPostsCreationPostEditorial/setInstagramChecked', false)
        this.$store.commit('socialPostsCreationPostEditorial/setGoogleChecked', false)
        this.$store.commit('socialPostsCreationPostEditorial/setLinkedInChecked', false)
        next()
      }
    } else {
      this.$store.commit('socialPostsCreationPostEditorial/resetPost')
      next()
    }
  },
  beforeMount () {
    // Réinitialiser l'état redirection seulement si on n'est pas en train de créer un modèle
    // ou si on n'a pas déjà sauvegardé un modèle
    if (this.$route.name !== 'post-editorial-modeles-create') {
      this.resetRedirection()
    }

    this.$store.commit('socialPostsCreationPostEditorial/setModalConfirmPublishNow', false)
    this.$store.commit('socialPostsCreationPostEditorial/SET_MODAL_DELETE_PLANIF_BROUILLONS', false)
    this.$store.commit('socialPostsCreationPostEditorial/setCustomFacebook', false)
    this.$store.commit('socialPostsCreationPostEditorial/setCustomGoogle', false)
    this.$store.commit('socialPostsCreationPostEditorial/setCustomInstagram', false)
    this.$store.commit('socialPostsCreationPostEditorial/setCustomLinkedIn', false)
    this.$store.commit('socialPostsCreationPostEditorial/setFacebookChecked', false)
    this.$store.commit('socialPostsCreationPostEditorial/setInstagramChecked', false)
    this.$store.commit('socialPostsCreationPostEditorial/setLinkedInChecked', false)
    this.$store.commit('socialPostsCreationPostEditorial/setGoogleChecked', false)
    this.$store.commit('socialPostsCreationPostEditorial/resetPost')
    this.$store.commit('socialPostsCreationPostEditorial/setCurrentPost', null)
    this.$store.commit('socialPostsCreationPostEditorial/checkDraftButtonState')

    this.post = this.$store.getters['socialPostsCreationPostEditorial/getPost']
    this.$route.meta.title = this.$t('routes.managePosts')
    this.post.typePlanif = 'publier'
    if (this.$route.params.id && this.$route.name === 'edit-post-editorial') {
      this.setCreate(false)
      this.setEdit(true)
      this.$store.dispatch('socialPostsCreationPostEditorial/loadSocialPostEditorialById', this.$route.params.id)
    } else if (this.$route.name === 'view-post-editorial' && this.$route.params.id) {
      this.readOnly = true
      this.$store.dispatch('socialPostsCreationPostEditorial/loadSocialPostEditorialById', this.$route.params.id)
    } else if (this.$route.name === 'post-editorial-modeles-use' && this.$route.params.id) {
      if (this.$route.params.login !== this.sitimmoUser.login) {
        this.fromReseau = true
      }
      this.$store.dispatch('socialPostsCreationPostEditorial/createPostFromModel', { id: this.$route.params.id, reference: this.$route.params.reference, fromReseau: this.fromReseau })
      this.setCreate(false)
      this.setEdit(true)
    } else if (this.$route.name === 'post-editorial-modeles-create') {
      this.setCreate(true)
      this.setEdit(false)
      this.model = true
    } else if (this.$route.name === 'post-editorial-modeles-edit' && this.$route.params.id) {
      this.$store.dispatch('socialPostsCreationPostEditorial/loadSocialPostEditorialById', this.$route.params.id)
      this.setCreate(false)
      this.setEdit(true)
      this.model = true
    } else {
      this.setCreate(true)
      this.setEdit(false)
      this.$store.commit('socialPostsCreationPostEditorial/setId', null)
      this.post = this.$store.getters['socialPostsCreationPostEditorial/getDefaultPost']
    }
    if (this.create === false) {
      this.titleLabel = 'Edition'
    } else {
      this.resetState()
    }
  }
}
</script>

<style lang="scss" scoped>
.textarea-with-emojis {
  position: relative;
}

.box-emojis {
  position: absolute;
  bottom: 0px;
  right: 10px;
}

.el-form-item__label {
  font-weight: bold;
}

.dialog-footer{
  display: flex;
  justify-content: flex-end;
}
</style>
